import { render } from "./RelatorioBalanceteIndex.vue?vue&type=template&id=27eca9ad&scoped=true&ts=true"
import script from "./RelatorioBalanceteIndex.vue?vue&type=script&lang=ts"
export * from "./RelatorioBalanceteIndex.vue?vue&type=script&lang=ts"

import "./RelatorioBalanceteIndex.vue?vue&type=style&index=0&id=27eca9ad&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27eca9ad"]])

export default __exports__